import { TransferDirectionEnum } from '../enums/TransferDirectionEnum';
import React from "react";

/**
 * Handles transfer direction change and clears corresponding fields
 */
export const handleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    direction: number | null,
    setValue: any
): void => {
    const value = parseInt(event.target.value);

    if (direction !== value) {
        setValue("direction", value);
    } else {
        setValue("direction", "");
    }

    // Reset arrival fields
    if (value === TransferDirectionEnum.DEPARTURE) {
        setValue("arrivalTransport", null);
        setValue("arrivalTransportReference", null);
        setValue("arrivalTransportReferenceNumber", null);
        setValue("arrivalTransportDate", null);
        setValue("arrivalTransportTime", null);
        setValue("arrivalNumberOfPassengers", null);
        setValue("arrivalLocationFrom", null);
        setValue("arrivalLocationTo", null);
        setValue("arrivalAddressDetailsFrom", null);
        setValue("arrivalAddressDetailsTo", null);
        setValue("arrivalVehicle", null);
    }

    // Reset departure fields
    if (value === TransferDirectionEnum.ARRIVAL) {
        setValue("departureTransport", null);
        setValue("departureTransportReference", null);
        setValue("departureTransportReferenceNumber", null);
        setValue("departureTransportDate", null);
        setValue("departureTransportTime", null);
        setValue("departureNumberOfPassengers", null);
        setValue("departureLocationFrom", null);
        setValue("departureLocationTo", null);
        setValue("departureAddressDetailsFrom", null);
        setValue("departureAddressDetailsTo", null);
        setValue("departureVehicle", null);
        setValue("pickUpTime", null);
    }
};

